import { styled } from 'stitches.config'
import { Stack } from 'components/Stack'

export const HeroRoot = styled('div', {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',

  '& .m-only': {
    display: 'block',
  },
  '& .d-only': {
    display: 'none',
  },
  '@bp2': {
    '& .m-only': {
      display: 'none',
    },
    '& .d-only': {
      display: 'block',
    },
  },
})

export const HeroContainer = styled('div', {
  position: 'relative',
  maxWidth: '500px',
  margin: '0 auto',
  display: 'flex',
  flexDirection: 'column',
  padding: '0 $2 $8',

  '@bp2': {
    maxWidth: '1292px',
    padding: '0 $2 $8',
    gap: '$4',
    flexDirection: 'row',
  },
  '@bp3': {
    gap: '$10',
  },
})

export const CopyColumn = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  width: '100%',

  '@bp2': {
    maxWidth: '634px',
    gap: '$3',
  },
})

export const Title = styled('h1', {
  fontSize: '$h2',
  marginBottom: '$1',
  '@bp2': {
    fontSize: '$h1',
    marginBottom: 0,
  },
})

export const Description = styled('p', {
  fontSize: '$body',
  marginTop: '$3',
  marginBottom: '$3',

  '@bp2': {
    marginBottom: 0,
    marginTop: 0,
  },
})

export const Span = styled('span', {
  textDecoration: 'line-through',
})

export const CallToAction = styled('p', {
  fontWeight: '$semiBold',
  fontSize: '$body',
  marginTop: '$1',
  display: 'none',

  '@bp2': {
    display: 'block',
  },
})

export const Feature = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  width: '100%',
  gap: '$1',

  '&:last-child, &:nth-last-child(2)': {
    marginTop: '8px',
  },

  marginTop: '8px',

  '@bp2': {
    width: '50%',
    marginTop: '12px',
    '&:first-child, &:nth-child(2)': {
      marginTop: 0,
    },
  },
})

export const FeaturesContainer = styled('div', {
  width: '100%',
  maxWidth: '590px',
  display: 'flex',
  flexWrap: 'wrap',
})

export const ImageColumn = styled('div', {
  width: '100%',
  display: 'flex',
  justifyContent: 'center',

  '@bp2': {
    maxWidth: '597px',
  },
})

export const ImageWrapper = styled('div', {
  position: 'relative',
  aspectRatio: '361/442',
  width: '100%',
  maxWidth: '500px',

  '@bp2': {
    width: '480px',
    height: '582px',
    aspectRatio: 'unset',
    maxWidth: 'none',
  },

  '@bp3': {
    width: '597px',
    height: '724px',
  },
})

export const FeatureText = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: '$1',
  marginRight: '$2',
})